
var viewportEls = document.querySelectorAll('.viewport');

if (viewportEls.length > 0) {

    var observer = new IntersectionObserver(function (entries) {
        // isIntersecting is true when element and viewport are overlapping
        // isIntersecting is false when element and viewport don't overlap

        entries.forEach(function (entry) {
            entry.target.classList.toggle('is-in-viewport', entry.isIntersecting);
        });
        
    }, { threshold: [0] }); // rootMargin: half ? '0px 0px -50% 0px' : '0px'

    viewportEls.forEach(function (el) {
        observer.observe(el);
    });

};
document.querySelectorAll('[data-target]').forEach(trigger => {
    trigger.addEventListener('click', function () {
        const selectors = this.getAttribute('data-target').split(',').map(s => s.trim());
        const className = this.getAttribute('data-class') || 'open';
        selectors.forEach(selector => {
            document.querySelectorAll(selector).forEach(targetEl => {
                targetEl.classList.toggle(className);
            });
        });
    });
});

document.querySelectorAll('[data-scroll]').forEach(trigger => {
  trigger.addEventListener('click', function() {
    const selectors = this.getAttribute('data-scroll').split(',').map(s => s.trim());
    selectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(targetEl => {

        const rootStyles = getComputedStyle(document.documentElement);
        const offsetPx = rootStyles.getPropertyValue('--scroll-offset').trim();
        let offset = 0;
        if (offsetPx) { offset = parseInt(offsetPx.replace('px', ''), 10) || 0; };
        const y = targetEl.getBoundingClientRect().top + window.pageYOffset - offset;

        window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  });
});